'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { BottomSheetWrapper, Backdrop, BottomSheetContent, Header, HeaderLabel, Body, Footer } from './BottomSheet.css.js';
import CloseIcon from '../Images/CloseIcon/index.js';
import { DEFAULT_OPTION, DEFAULT_FOOTER_OTPION } from './constants.js';
import Button from '../Button/index.js';

var BottomSheet = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, header = props.header, headerOption = props.headerOption, children = props.children, footer = props.footer, options = props.options, footerOptions = props.footerOptions, onClose = props.onClose, trackingOnClose = props.trackingOnClose, _b = props.styleOption, styleOption = _b === void 0 ? {} : _b;
    var mergedOption = __assign(__assign({}, DEFAULT_OPTION), options);
    var mergedFooterOptions = __assign(__assign({}, DEFAULT_FOOTER_OTPION), footerOptions);
    var _c = useState(false), isMounted = _c[0], setMounted = _c[1];
    var _d = useState(true), isCloseModal = _d[0], setCloseModal = _d[1];
    var removeOverflowClass = function () {
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
    };
    var onAnimationEnd = function () {
        if (!isCloseModal) {
            return;
        }
        removeOverflowClass();
        setMounted(false);
        onClose(false);
    };
    var onClickFooterButton = function () {
        mergedFooterOptions.isCloseOnClick && setCloseModal(true);
        mergedFooterOptions.callbackOnClick && mergedFooterOptions.callbackOnClick();
        trackingOnClose && trackingOnClose('BUTTON');
    };
    useEffect(function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (!bodyNode) {
            return;
        }
        if (isMounted) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        return function () {
            removeOverflowClass();
        };
    }, []);
    useEffect(function () {
        setCloseModal(!isOpen);
        if (isOpen) {
            setMounted(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return createPortal(isMounted ? (React__default.createElement(BottomSheetWrapper, { "data-cname": 'BottomSheet', zIndex: styleOption.zIndex },
        React__default.createElement(Backdrop, { onClick: function () {
                mergedOption.isCloseOnClickBackdrop && setCloseModal(true);
                trackingOnClose && trackingOnClose('BACKDROP');
            } }),
        React__default.createElement(BottomSheetContent, { isClose: isCloseModal, onAnimationEnd: onAnimationEnd },
            header && (React__default.createElement(Header, { isReverseHeader: mergedOption.isReverseHeader, style: __assign({}, headerOption === null || headerOption === void 0 ? void 0 : headerOption.styles) },
                React__default.createElement(HeaderLabel, null, header),
                mergedOption.isHaveCloseIcon && (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                        setCloseModal(true);
                        trackingOnClose && trackingOnClose('BACKDROP');
                    } },
                    React__default.createElement(CloseIcon, null))))),
            React__default.createElement(Body, null, children),
            footer || (React__default.createElement(Footer, null,
                React__default.createElement(Button, { type: mergedFooterOptions.buttonType, onClick: onClickFooterButton, style: { width: '100%' } }, mergedFooterOptions.text)))))) : (React__default.createElement(React__default.Fragment, null)), document === null || document === void 0 ? void 0 : document.body);
};

export { BottomSheet as default };
//# sourceMappingURL=index.js.map
